import { NoteBody } from '@/components/ui/note-popover';
import type { TimeLog } from '@/lib/api';
import { hoursNum } from '@/lib/format';
import { categoryLabel } from '@/lib/timelogs';

/**
 * グリッドのマスに出すその日のメモ。
 *
 * 同じ日に複数の記録が入ることがあるので、どのメモがどの記録のものか
 * 分かるようカテゴリと工数を添える (マスの数字だけでは 1 件に決まらない)。
 */
export function CellNotes({ logs }: { logs: TimeLog[] }) {
  return (
    <div className="flex flex-col gap-2 divide-y divide-line">
      {logs.map((log) => (
        <div key={log.id} className="flex flex-col gap-1">
          <span className="font-mono text-[10px] tracking-wider text-ink-faint">
            {categoryLabel(log.category)} {hoursNum(log.hours)} h
          </span>
          <NoteBody note={log.note ?? ''} />
        </div>
      ))}
    </div>
  );
}
